import type { MediaSize } from 'react-easy-crop';

/**
 * Suggests an initial zoom so portrait or square images fill a wide crop area (e.g. 4:1).
 */
export function getWideCropInitialZoom(media: MediaSize, cropAspect: number): number {
  const { width, height } = media;
  if (!width || !height) {
    return 1;
  }

  const mediaAspect = width / height;
  if (mediaAspect >= cropAspect) {
    return 1;
  }

  const suggested = cropAspect / mediaAspect;
  return Math.min(4, Math.max(1, suggested * 0.95));
}
